import { mapCheckoutAccommodationItemToProduct } from 'checkout/lib/analytics/checkoutUAMappers'
import { OfferPackageOptionView } from 'selectors/offerPageSelectors'

export interface OptimizelyEvent {
  type: 'event'
  eventName: string
  tags?: any
}

export function searchFromHomepageEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-from-homepage',
  }
}

export function clickHomepageTrendingDestinationEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-trending-destinations-event',
  }
}

export function clickHomepageNavbarEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-navbar',
  }
}

export function clickHomepageTileEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-homepage-tile',
  }
}

export function purchaseClickEvent(order: App.Order): OptimizelyEvent {
  const {
    id: orderId,
    currencyCode,
    source,
    leLabel,
    total,
    tourItems,
    experienceItems,
    flightItems,
    items: accommodationItems,
    bedbankItems,
  } = order

  return {
    type: 'event',
    eventName: 'transaction',
    tags: {
      revenue: total * 100,
      currency: currencyCode,
      value: total,
      orderId,
      source,
      affiliation: leLabel === 'scoopontravel' ? 'travel' : source, // logic taken from src/client/analytics/eventDefinitions[function transaction]
      tourItems,
      experienceItems,
      flightItems,
      accommodationItems,
      bedbankItems,
    },
  }
}

export function addToCartAccommodationEvent(
  offer: App.Offer | App.OfferSummary,
  packageOption: OfferPackageOptionView | undefined,
  reservationType: string,
): OptimizelyEvent {
  const tags = mapCheckoutAccommodationItemToProduct(offer, packageOption, reservationType)

  return {
    type: 'event',
    eventName: 'add-to-cart-accommodation',
    tags,
  }
}

export function tpfmCarouselClickEvent() : OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-tpfm-carousel',
  }
}

export function hotelsPageOfferClickEvent(source: string) : OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-offer-on-hotels-page',
    tags: {
      offer_source: source,
    },
  }
}

export function accommodationOfferClickedEvent(offer: any): OptimizelyEvent {
  const accommodationPrice = (offer?.lowestPricePackage?.price + offer?.lowestPricePackage?.propertyFees) || 0

  return {
    type: 'event',
    eventName: 'accommodation-offer-clicked',
    tags: {
      item_id: offer?.id,
      item_name: offer?.name,
      value: accommodationPrice,
    },
  }
}

export function successfulSignupEvent(details: any, prevState: any): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'signup-complete',
    tags: {
      signupSource: prevState.auth.source,
      userCountry: details.userDetails.userCountry,
      utmMedium: details.userDetails.utmMedium,
      utmSource: details.userDetails.utmSource,
    },
  }
}

export function upgradePackageEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'package-upgraded',
  }
}

export function searchClickOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-offer',
  }
}

export function searchClickLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-lpc-offer',
  }
}

export function purchaseLpcOffer(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'purchase-lpc-offer',
  }
}

export function clickTourOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-tour-offer',
  }
}

/*
 * This is a view tour checkout event, rather than an add to cart event.
 * This will be updated in the future to reflect that.
*/
export function addToCartTourEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'add-to-cart-tour',
  }
}

/*
 * This should be fired when the user clicks "book now", "review & payment", or similar.
 * Essentially just before the user is expected to proceed to the checkout.
*/
export function addToCartEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'add-to-cart',
  }
}

export function purchaseTourOfferEvent(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'purchase-tour-offer',
  }
}

export function viewOfferEvent(offer: any): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'view-offer',
    tags: {
      item_id: offer?.id,
      item_name: offer?.name,
    },
  }
}

export function clickSearchOfferNearby(): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'click-search-offer-nearby',
  }
}
